import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchBulletins } from '../../api/bulletin';
import { MENU_BOARD } from '../layout/Header';
import { useCompanyStore } from '../../store/companyStore';
import { BulletinPost } from '../../types/bulletin';
import './ListWidgets.css';

function formatDate(value?: string | null) {
  if (!value) return '-';
  return value.slice(0, 10);
}

function NoticesWidget() {
  const navigate = useNavigate();
  const companyId = useCompanyStore((s) => s.companyId);
  const [rows, setRows] = useState<BulletinPost[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fetchBulletins({ page: 0, size: 8 });
      setRows(result.content ?? []);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [companyId, load]);

  const openBoard = () => {
    navigate('/app', { state: { activeMenu: MENU_BOARD } });
  };

  return (
    <section className="ec-widget ec-list-widget">
      <div className="ec-widget__header">
        <div className="ec-list-widget__title">
          <strong>공지사항</strong>
        </div>
        <div className="ec-widget__actions">
          <button type="button" className="ec-tool-btn" title="새로고침" onClick={() => void load()}>
            ↻
          </button>
          <button type="button" className="ec-tool-btn" title="게시판 열기" onClick={openBoard}>
            ⋯
          </button>
        </div>
      </div>

      <div className="ec-table-wrap">
        <table className="ec-table">
          <thead>
            <tr>
              <th>제목</th>
              <th style={{ width: '88px' }}>작성자</th>
              <th style={{ width: '90px' }}>날짜</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3}>불러오는 중...</td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={3}>
                  <button type="button" className="ec-table__link" onClick={openBoard}>
                    등록된 글이 없습니다. 게시판에서 작성하기
                  </button>
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.postId}>
                  <td>
                    <button type="button" className="ec-table__link" onClick={openBoard}>
                      {row.pinned ? <span className="ec-notice-tag">공지</span> : null}
                      {row.title}
                    </button>
                  </td>
                  <td>{row.authorName || '-'}</td>
                  <td className="ec-table__date">{formatDate(row.createdAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default NoticesWidget;
